module.exports = __webpack_public_path__ + "images/ing41a8586affbc6be4987ab2f4048d23e0.png";